import { useEffect, useRef } from "react";
import '@splidejs/react-splide/css';
import { useTranslation } from "react-i18next";

import "./stepHeader.css";

export default function StepsHeader({step, setInvoiceStep, maxStep}) {
    const { t } = useTranslation('basic');

    return (
        <div className="stepsHeaderWrapper gradient_bg_header" style={{
            paddingBottom: "3.45rem"
        }}>
            <div className="stepHeaderHeader heading-h4">
                {t("chat_with_manager_title")}
                <img id="stepsHeaderImage" src="https://s3.timeweb.com/8a6e091b-publick/tracking_start.png"/>
            </div>
        </div>
    )
}